var c3 = require('c3');
export default function ($stateProvider) {
    /*
        TODO: Enable filtering by:
        - Activity
        - Cognitive Function
        - GDS
        - Category
    */
    $stateProvider.state('stats1', {
        parent: 'ng-admin',
        url: '/stats/exercises_per_cf',
        params: { },
        controller: [
            'endpoint',
            '$auth',
            '$window',
            function(endpoint, $auth, $window) {
                var centerId = $window.localStorage.getItem('center_id');
                $auth.validateToken()
                    .then(function() {
                        var chart = c3.generate({
                            bindto: '#chart',
                            data: {
                              mimeType: 'json',
                              url: endpoint + '/centers/' + centerId + '/dashboard/exercises_per_cf',
                              headers: $auth.retrieveData('auth_headers'),
                              keys: {
                                  x: 'cf',
                                  value: ['exercises'],
                              },
                              type: 'bar'
                            },
                            axis: {
                                x: {
                                    type: 'category'
                                }
                            },
                            legend: {
                                hide: true
                            }
                        });
                });
            }
        ],
        template: "<h1>{{ \"STAT_TITLE_EXERCISES_PER_CF\" | translate }}</h1><div id='chart'></div>"
    });
};



// WEBPACK FOOTER //
// ./js/stats/exercisesPerCF.js